import styled from 'styled-components';
import background from '../../../../assets/img/girl-playing.jpg';

export const Container = styled.section`
  width: 100vw;
  height: 60rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: white;
`;

export const ItemsDiv = styled.div`
  padding: 10rem 5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 60rem;
`
export const WomanDiv = styled.div`
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 60rem;
`

export const ItemDiv = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`

export const ItemIcon = styled.img`
  width: 5rem;
  height: auto;
  border-radius: 50%;
  margin-right: 1rem;
`

export const ItemText = styled.span`
  font-weight: 700;
  font-size: 2rem;
  font-family: 'Montserrat', sans-serif;
  color: #131e23;
`